
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  flex-direction:column;
}

.sidebar-block{
  background:var(--brand-gray-200);
  background:var(--sidebar-block-bg, var(--brand-gray-200));
  padding:var(--spacing-4);
  padding:var(--sidebar-block-padding, var(--spacing-4));
}

.rule{
  display:block;
  display:var(--sidebar-rule-display, block);
  height:3px;
  width:100%;
  padding:0;
  border:solid var(--brand-green-900);
  border:solid var(--sidebar-rule-color, var(--brand-green-900));
  border-width:8px 0 0;
  border-radius:3px;
  border-top-width:3px;
  margin-top:var(--spacing-2);
  margin-bottom:var(--spacing-4);
}

@media (min-width: 1024px){

.rule{
    margin-top:var(--spacing-7);
    margin-bottom:var(--spacing-6)
}
  }
`;